import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      '& .MuiGrid-root': {
        width: '100%',
      },
      '& .MuiTabs-root': {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
      },
    },
    '& .link-text': {
      display: 'block',
      color: theme.mixins.AbuDhabiOrange(),
    },
    '& .countrySection': {
      ...theme.mixins.paddingRight(theme.spacing(3)),
      marginBottom: theme.spacing(6),
      color: theme.palette.text.darkGrey,
      '& .heading': {
        color: theme.palette.text.primary,
      },
    },
  },
  officeHeading: {
    ...theme.mixins.marginLeft(pxToRem(-10)),
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.marginLeft(theme.spacing(-2)),
    },
  },
}));

export default useStyles;
